import { TextStyle } from "@pixi/text";
import { FitText } from "../FitText";
import { getDefaultFontFamily } from "../../TextUtils";
import { ButtonOptions } from "./ButtonOptions";
import { ScaleUpButton } from "./ScaleUpButton";
import { AudioManager } from "../../../../audio/AudioManager";

export class ScaleUpButtonWithText extends ScaleUpButton {
    public constructor(
        options: ButtonOptions,
        audioManager: AudioManager
    ) {
        super(options, audioManager);
        const text = new FitText(options.textOptions.text, new TextStyle({
            fontFamily: getDefaultFontFamily(),
            fontSize: options.textOptions.fontSize,
            fill: options.textOptions.fill,
            lineJoin: "round",
            align: "center"
        }),
            options.textOptions.autoFitWidth,
            options.textOptions.autoFitHeight
        );
        this.addChild(text);
        text.position.set(
            options.textOptions.positionOption.x,
            options.textOptions.positionOption.y || (this.height - text.height) * 0.5 + options.textOptions.offsetOption.y,
        )
    }
}